export default {
    namespaced: true,

    state: () => ({
        isSyncing: false,
        startTime: null,
        progress: 0,
        cancelSource: null,
        progressInterval: null
    }),

    mutations: {
        START_SYNC(state, cancelSource) {
            state.isSyncing = true;
            state.startTime = Date.now();
            state.progress = 0;
            state.cancelSource = cancelSource;

            // Start simulated progress
            if (state.progressInterval) {
                clearInterval(state.progressInterval);
            }

            state.progressInterval = setInterval(() => {
                // Gradually increase up to 90%
                if (state.progress < 90) {
                    state.progress += 1;
                }
            }, 1000);
        },

        UPDATE_PROGRESS(state, value) {
            state.progress = value;
        },

        STOP_SYNC(state) {
            state.isSyncing = false;
            state.startTime = null;

            // Jump to 100% on completion
            state.progress = 100;

            if (state.progressInterval) {
                clearInterval(state.progressInterval);
                state.progressInterval = null;
            }

            state.cancelSource = null;
        },

        CLEAR_SYNC(state) {
            state.isSyncing = false;
            state.startTime = null;
            state.progress = 0;
            state.cancelSource = null;

            if (state.progressInterval) {
                clearInterval(state.progressInterval);
                state.progressInterval = null;
            }
        },

        CANCEL_SYNC(state) {
            if (state.cancelSource) {
                state.cancelSource.cancel("User cancelled sync");
            }

            if (state.progressInterval) {
                clearInterval(state.progressInterval);
                state.progressInterval = null;
            }

            state.isSyncing = false;
            state.startTime = null;
            state.progress = 0;
            state.cancelSource = null;
        }
    },

    getters: {
        elapsedSeconds: (state) => {
            if (!state.isSyncing || !state.startTime) return 0;
            return Math.floor((Date.now() - state.startTime) / 1000);
        }
    }
};